export default "__VITE_ASSET__DCx1vTh7__"